import { useLocation } from 'react-router-dom';
import { useCasesData } from '../Common/UseCasesData';

function UseCases(){

    const isShowConsole = process.env.NODE_ENV === 'development';

    const location = useLocation();
    isShowConsole && console.log("Current Path:", location.pathname); 

    const useCasesElements = useCasesData.map((ele, idx) => {
        return(
            <div className='useCasesEle' key={idx}>
                <div className='role'>{ele.role}</div>
                <div className='useCases'>{ele.usecases}</div>
            </div>
        )
    });

    return(
        <div id='use-cases' className='useCasesContainer'>
            <div className='useCasesWrapper'>
                <div className='contentDiv'>
                    <div className='containerDiv'>
                        <div className='title'>
                            <div className='main'>Use Cases</div>
                            <h2 className='sub'>(Real world use cases for our OCR tool)</h2>
                        </div>
                        <div className='content'>
                            <div className='useCasesCont'>
                                {useCasesElements}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default UseCases;